import { t } from 'i18n'
import { memo } from 'react'
import { Doughnut } from 'react-chartjs-2'
import styled from 'styled-components'
import ChartContainer from './ChartContainer'

const StyledDoughnutChart = styled(Doughnut)`
  margin-top: 2rem;
  width: 100% !important;
  max-height: 400px;
`

interface DoughnutChartProps {
  labels: string[]
  data: number[]
  title: string
}

const DoughnutChart = ({ labels, data, title }: DoughnutChartProps) => {
  if (!data) return null

  const colors = [
    '#e60049',
    '#0bb4ff',
    '#50e991',
    '#e6d800',
    '#9b19f5',
    '#ffa300',
    '#dc0ab4',
    '#b3d4ff',
    '#00bfa0',
    '#7c1158',
    '#4421af',
    '#1a53ff',
    '#b2e061',
    '#bd7ebe',
    '#ffb55a',
    '#ffee65',
    '#27aeef'
  ]

  const options = {
    responsive: true,
    scales: {
      y: {
        display: false
      },
      x: {
        display: false
      }
    },

    plugins: {
      datalabels: {
        color: '#fff',
        display: 'auto'
      },
      legend: {
        position: 'right' as const,
        labels: {
          padding: 16,
          font: {
            size: 16
          },
          pointStyle: 'circle',
          usePointStyle: true
        }
      },
      title: {
        display: false
      }
    }
  }

  const defaultData = {
    labels: labels.map(label => t(label)),
    datasets: [
      {
        data,
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1
      }
    ]
  }

  return (
    <ChartContainer title={title}>
      <StyledDoughnutChart data={defaultData} options={options} />
    </ChartContainer>
  )
}

export default memo(DoughnutChart)
